import React, { Component } from "react";
import { Navigation, Header } from "..";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./app-view-wrapper.scss";

class AppViewWrapper extends Component {
  state = { isNavShrink: false };

  handleNavigationToggle = () => {
    this.setState({ isNavShrink: !this.state.isNavShrink });
  };

  handleSubMenuOpen = () => {
    const { isNavShrink } = this.state;
    if (isNavShrink && window.innerWidth > 1240) {
      this.setState({ isNavShrink: false });
    }
  };
  removeNavShrink = () => {
    if (this.state.isNavShrink && window.innerWidth <= 1240)
      this.setState({ isNavShrink: false });
  };

  handleMobileNavShrink = () => {
    if (!this.state.isNavShrink && window.innerWidth <= 1240)
      this.setState({ isNavShrink: true });
  };

  render() {
    const { isNavShrink } = this.state;
    const { children, location } = this.props;
    return (
      <div className="product-container">
        <div className="product-view-container" onClick={this.removeNavShrink}>
          <Header
            hideUserSetting={true}
            onNavigationToggle={this.handleNavigationToggle}
          />
          {children}
        </div>
      </div>
    );
  }
}
AppViewWrapper.defaultProps = {
  className: "",
};
const mapStateToProps = ({ notification }) => {
  return { notification };
};
export default connect(mapStateToProps)(withRouter(AppViewWrapper));
